import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/secondary-school/layoutProps';
import ichk from '../../../../../static/ichk.jpg';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="through-train-to-ichk">
    <h1>Through Train to ICHK</h1>
    <p>
      Kingston is a founding partner of International College Hong Kong (ICHK), which ensures that all of our graduates
      have a guaranteed placement in a quality secondary school that offers the IB Diploma. ICHK is small by intention
      and fuelled by a commitment to provide students with a cutting-edge, research driven education. That is why class
      sizes are small, the curriculum personalized and innovative, the campus green and spacious, teachers genuinely
      committed and passionate, and the community intimate and enabling.
    </p>
    <p>
      Students at ICHK gain internationally recognised academic qualifications, whilst developing the essential life
      skills of critical thinking, leadership, personal resilience, collaboration and independent learning.
    </p>
    <a
      href="https://www.ichk.edu.hk/home/our-school/secondary/"
      target="_blank"
      rel="noopener noreferrer"
      className={styles.ichk}
    >
      <img src={ichk} alt="ICHK" />
    </a>
  </ContentLayout>
);
